import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import { z } from "zod/v4"

const Invitation = lazy(() =>
  import("#pages/login/invitation.tsx").then((m) => ({ default: m.Invitation })),
)

const searchSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  name: z.string().optional(),
  role: z.string().optional(),
  org: z.string().optional(),
  orgId: z.string().optional(),
})

export const Route = createFileRoute("/_auth/invitation")({
  staticData: { title: "Invitation" },
  validateSearch: searchSchema,
  component: InvitationRoute,
})

function InvitationRoute() {
  const search = Route.useSearch()
  return <Invitation {...search} />
}
